import { Input as AntInput } from 'antd';
import type { InputProps as AntInputProps } from 'antd';
import type React from 'react';

import { withAuthGuard } from '../../auth';
import type { AuthProps } from '../../auth';

export type InputProps = AntInputProps & AuthProps;

const GuardedInput = withAuthGuard(AntInput, {
    defaultFallback: 'disable',
}) as unknown as React.ForwardRefExoticComponent<InputProps & React.RefAttributes<HTMLInputElement>>;

/**
 * Themed, auth-gated pass-through of antd's `Input`. Sub-components
 * (`TextArea`/`Search`/`Password`/`Group`) are re-exported unchanged — they
 * cover distinct interaction patterns not part of the base `auth` contract
 * (gate the base `Input` used inside them if needed).
 */
export const Input = Object.assign(GuardedInput, {
    TextArea: AntInput.TextArea,
    Search: AntInput.Search,
    Password: AntInput.Password,
    Group: AntInput.Group,
});
